import React from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';

const TimeInfoIcon = () => {
  return (
    <Icon
      name="info-circle"
      onClick={() => {
        window.open('http://learn.shoflo.tv/timing-basics/timing-basics');
      }}
    />
  );
};

export default TimeInfoIcon;
